import { gql } from '@apollo/client';
import type { BookmarkFolder } from 'types';
import type { CreateFolderError, DeleteFolderError, UpdateFolderError } from 'graphql/folder';
import { BOOKMARK_FOLDER_FRAGMENT } from './AdminBookmarkFolderFragments';

export const CREATE_BOOKMARK_FOLDER_MUTATION = gql`
  mutation CreateBookmarkFolder($createFolderInput: CreateFolderInput!) {
    createFolder(createFolderInput: $createFolderInput) {
      __typename
      ... on CreateFolderOutput {
        folder {
          ...BookmarkFolder
        }
        errorReason
      }
    }
  }
  ${BOOKMARK_FOLDER_FRAGMENT}
`;

export type CreateBookmarkFolderOutput = {
  createFolder: {
    errorReason: CreateFolderError;
    folder: BookmarkFolder;
  };
};

export const UPDATE_BOOKMARK_FOLDER_MUTATION = gql`
  mutation UpdateBookmarkFolder($adminUpdateFolderInput: AdminUpdateFolderInput!) {
    adminUpdateFolder(adminUpdateFolderInput: $adminUpdateFolderInput) {
      __typename
      ... on AdminUpdateFolderOutput {
        folder {
          ...BookmarkFolder
        }
      }
      ... on AdminUpdateFolderErrorOutput {
        errorReason
      }
    }
  }
  ${BOOKMARK_FOLDER_FRAGMENT}
`;

export type UpdateBookmarkFolderOutput = {
  adminUpdateFolder: {
    errorReason: UpdateFolderError;
    folder: BookmarkFolder;
  };
};

export const DELETE_BOOKMARK_FOLDER_MUTATION = gql`
  mutation DeleteBookmarkFolder($deleteFolderInput: DeleteFolderInput!) {
    deleteFolder(deleteFolderInput: $deleteFolderInput) {
      __typename
      ... on DeleteFolderOutput {
        errorReason
        isDeleted
      }
    }
  }
`;

export type DeleteBookmarkFolderOutput = {
  deleteFolder: {
    errorReason: DeleteFolderError;
    isDeleted: boolean;
  };
};